module.exports = __webpack_public_path__ + "assets/img/b2.4d9b38cd.jpg";